import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cms-destination-flight-info',
  templateUrl: 'cms-destination-flight-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsDestinationFlightInfoComponent {}
